import clsx from "clsx"
import React from "react"
import { AiOutlineInfoCircle } from "react-icons/ai"
import { FaChevronRight } from "react-icons/fa"

import { StarRating } from "@components/maker"
import { BasicLink } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@const/pictures"
import { CourseDetail } from "@interfaces/course/course-detail"
import { priceFormatter, textShortener } from "@lib/functions"
import Image from "next/image"
import { CourseShare } from "./CourseShare"

interface ClassBannerProps {
  screenWidth: number
  courseDetail: CourseDetail
}

export const CourseBanner: React.FC<ClassBannerProps> = ({ screenWidth, courseDetail }) => {
  if (!courseDetail) {
    return <></>
  }

  const {
    course_categories: category,
    course_name: classTitle,
    course_banner: banner,
    course_slug: slug,
    course_info: info,
    course_label,
  } = courseDetail

  return (
    <section className={clsx("sm:h-[55vw] relative", "h-auto")}>
      <Image
        alt="banner-image"
        width={1440}
        height={798}
        className={clsx(
          "sm:h-[55vw] sm:w-auto absolute top-0 z-[-1] object-cover",
          "w-full h-full"
        )}
        src={
          screenWidth > 576
            ? `${HARISENIN_PUBLIC_PAGE_ASSETS}/class_detail.png`
            : `${HARISENIN_PUBLIC_PAGE_ASSETS}/class_detail-mobile.png`
        }
      />

      <div
        className={clsx(
          "sm:pt-[80px] top-0 left-0 bg-banner flex flex-col sm:justify-center h-full",
          "pt-8"
        )}
      >
        <div className={clsx("sm:absolute top-20 w-full sm:block", "hidden")}>
          <Container>
            <FlexBox
              className="gap-3.5 text-white sm:w-[calc(75%-40px)] sm:pr-4"
              align="center"
              id="header"
            >
              <div>Beranda</div>

              <FaChevronRight className="text-xs" />

              <BasicLink href={`/category/${category[0].category_slug}`}>
                {category[0].category_name}
              </BasicLink>

              <FaChevronRight className="text-xs" />

              <div title={classTitle}>{textShortener(classTitle, 40)}</div>
            </FlexBox>
          </Container>
        </div>

        <div className={clsx("fade_in_left my-0")}>
          <Container>
            {/* {course_label === "PRAKERJA" && (
              <FlexBox
                className={clsx(
                  "bg-[rgba(255,255,255,0.8)] text-green sm:rounded-10 sm:px-6 sm:py-2.5 w-fit gap-3 sm:text-lg mb-3 font-semibold",
                  "text-sm rounded py-2 px-4"
                )}
                align="center"
              >
                <IoCopy /> <span>Prakerja</span>
              </FlexBox>
            )} */}

            <h1
              className={clsx(
                "mb-[18px] text-white sm:w-1/2 font-semibold sm:text-4xl sm:leading-[52px]",
                "w-full text-2xl leading-[36px]"
              )}
            >
              {banner.banner_title}
            </h1>

            <div
              className={clsx(
                "sm:text-lg text-white sm:leading-[174%] sm:mb-10 sm:w-1/2",
                "text-sm leading-[18px] w-[80%] mb-3"
              )}
            >
              {banner.banner_subtitle}
            </div>

            <FlexBox className="gap-3">
              <StarRating value={banner.course_rating} className={clsx("sm:", "text-sm")} />
              <div className="text-sm text-white font-semibold">
                {banner.course_rating} ({courseDetail.course_total_review} Rating)
              </div>
            </FlexBox>

            {screenWidth < 576 && (
              <>
                <FlexBox align="center" className="mt-9 w-3/4 mb-3">
                  {info.discount_price > 0 && (
                    <div className="text-white line-through  font-semibold mr-4">
                      {priceFormatter(info.discount_price)}
                    </div>
                  )}

                  <div className="text-2xl text-white font-semibold">
                    {priceFormatter(info.nett_price)}
                  </div>
                </FlexBox>

                {info.discount_price > 0 && (
                  <div className="mb-6">
                    <div className="bg-red text-white text-sm w-fit rounded px-1.5 py-1 font-semibold">
                      -{info.discount_percentage}%
                    </div>
                  </div>
                )}

                {info.offer && (
                  <FlexBox align="center" className="text-yellow text-sm mb-[18px] gap-3">
                    <AiOutlineInfoCircle className="text-lg" />
                    <div className="font-semibold">{info.offer}</div>
                  </FlexBox>
                )}

                <CourseShare screenWidth={screenWidth} slug={slug} />
              </>
            )}
          </Container>
        </div>
      </div>
    </section>
  )
}
